import without from 'lodash/without';
export function hasItemExpanded({ expandedItems, key, }) {
    return expandedItems.indexOf(key) > -1;
}
export function buildDisplayItemStyles({ isExpanded, baseCssClass, }) {
    const modifier = isExpanded ? 'expanded' : 'hidden';
    const cssClass = `${baseCssClass}__panel ${baseCssClass}__panel--${modifier}`;
    const titleBaseCssClass = `${baseCssClass}__title`;
    const iconBaseCssClass = `${baseCssClass}__icon`;
    const buttonCssClass = isExpanded
        ? `${baseCssClass}__button ${baseCssClass}__button--expanded`
        : `${baseCssClass}__button`;
    const itemBaseCssClass = `${baseCssClass}__item`;
    const headerBaseCssClass = `${baseCssClass}__header`;
    return {
        cssClass,
        titleBaseCssClass,
        iconBaseCssClass,
        buttonCssClass,
        itemBaseCssClass,
        headerBaseCssClass,
    };
}
export function handleAccordionNavClick({ expandedItemsState, itemKey, singleExpansion, }) {
    const isActive = expandedItemsState.indexOf(itemKey) > -1;
    let expandedItems = expandedItemsState;
    if (singleExpansion) {
        expandedItems = isActive ? [] : [itemKey];
    }
    else if (isActive) {
        expandedItems = without(expandedItems, itemKey);
    }
    else {
        expandedItems.push(itemKey);
    }
    return {
        expandedItems,
    };
}
